import { connect } from 'react-redux'
import { FamilyComponent } from './FamilyComponent'
import type { RootState } from 'shared/store/reducers'
import { deleteKid } from 'shared/store/kingdom/profile'
import type { Dispatch } from 'redux'

const mapStateToProps = (state: RootState) => state.kingdomProfilePageState

const mapDispatchToProps = (d: Dispatch<any>) => ({
    deleteKid: (id: string) => d(deleteKid(id))
})

const Family = connect(mapStateToProps, mapDispatchToProps)(FamilyComponent)

export { Family }
